export class DeleteItemService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(data) {
    return await this.httpClient.post('/v01/pedidos/ExcluiPedido/', data)
  }
}
